import React, { Component } from 'react';
import InfoIcon from 'images/info.svg';

export default class LabelWithTooltip extends Component {
  render() {
    const { label, tooltip } = this.props;

    return (
      <div className="label-with-tooltip">
        <p className="label-with-tooltip__label">{label}</p>
        <div className="label-with-tooltip__tooltip">
          <img src={InfoIcon} className="label-with-tooltip__icon" alt="info icon" />
          <div className="label-with-tooltip__content">{tooltip}</div>
        </div>
      </div>
    );
  }
}
